import React, { Component } from 'react';

class Notification extends Component {
    state = {}
    render() { 
        return ( 
            <div className="submittedNotification" style={{display: this.props.show_added_notification}}><i className="far fa-check-circle"></i> <span> </span>{this.props.form_heading}</div>
        )
    }
}
 
export default Notification;


// WEBPACK FOOTER //
// ./src/Components/Notifications/Notifications.jsx